var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleExclamation = function SvgCircleExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A74D46",
    d: "M11.998 3.6a8.4 8.4 0 1 1 0 16.8 8.4 8.4 0 0 1 0-16.8m0 18a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2m.6-14.4h-1.2v6h1.2zm-1.5 9h1.8v-1.8h-1.8z"
  })));
};
export default SvgCircleExclamation;